import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { authSelectors } from 'app-components/flux/auth';

import { bugsnagIdentify } from 'utils/core/bugsnag';

window.crashJS = (crash = 'Simulate JS Crash') => {
  setTimeout(() => {
    throw new Error(crash);
  }, 0);
};

window.testAssert = (message = 'Test Assert') => {
  assert(false, message);
};

const Bugsnag = () => {
  const authSession = useSelector(authSelectors.getAuthSession);

  useEffect(() => {
    if (authSession.qcsId) {
      bugsnagIdentify(authSession.qcsId, authSession.datasetId);
    }
  }, [authSession.qcsId, authSession.datasetId]);

  // simulate crash from console: crash('message')
  const [crash, setCrash] = useState('');
  useEffect(() => {
    window.crashUI = (error = 'Simulate UI Crash') => setCrash(error);
    if (crash) {
      throw new Error(crash);
    }
    return () => {
      if (window?.crashUI) {
        // @ts-expect-error crashUI is declared as required
        delete window.crashUI;
      }
    };
  }, [crash, setCrash]);

  return null;
};

declare global {
  // @ts-expect-error FIXME TS7010
  function crashUI(error?: string);
  // @ts-expect-error FIXME TS7010
  function crashJS(error?: string);
  // @ts-expect-error FIXME TS7010
  function testAssert(error?: string);
}

export default Bugsnag;
